/**
 * LocalStorageにリダイレクトURLをセットする
 */
export function setSpaceRedirectUrl() {
  const localStorageParams = JSON.parse(localStorage.getItem('search_params') || '{}')
  localStorageParams.redirect_url = location.href
  localStorage.setItem('search_params', JSON.stringify(localStorageParams))
}
